import React, { useState } from 'react';
import { toast } from 'react-toastify';

export const clearToasts = () => {toast.dismiss()};

const ExpandableToastMessage = ({ message, detail }: { message: React.ReactNode; detail: string }) => {
    const [open, setOpen] = useState(false);
    const [copied, setCopied] = useState(false);

    const handleCopy = (e: React.MouseEvent) => {
        e.stopPropagation();
        navigator.clipboard.writeText(detail).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div>
            <div>{message}</div>
            <button
                type='button'
                onClick={e => { e.stopPropagation(); setOpen(o => !o); }}
                style={{
                    background: 'none',
                    border: 'none',
                    padding: '3px 0 0',
                    cursor: 'pointer',
                    color: 'inherit',
                    textDecoration: 'underline',
                    display: 'block',
                    fontSize: '0.75rem',
                }}
            >
                {open ? '▲ Hide details' : '▼ Show details'}
            </button>
            {open && (
                <div style={{
                    marginTop: '4px',
                    fontSize: '0.75rem',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    maxHeight: '120px',
                    overflowY: 'auto',
                    backgroundColor: 'rgba(0,0,0,0.15)',
                    borderRadius: '3px',
                    padding: '4px 6px',
                }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '2px' }}>
                        <button
                            type='button'
                            onClick={handleCopy}
                            style={{
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                cursor: 'pointer',
                                color: 'inherit',
                                textDecoration: 'underline',
                                fontSize: '0.7rem',
                            }}
                        >
                            {copied ? 'Copied!' : 'Copy'}
                        </button>
                    </div>
                    {detail}
                </div>
            )}
        </div>
    );
};

export const infoToast = (
    msg: React.ReactNode | string,
    { autoClose = 3999 }: Pick<MessageOptions, 'autoClose'> = {}
) => {
    toast.info(msg, {
        position: 'top-center',
        pauseOnHover: false,
        hideProgressBar: true,
        autoClose,
        closeOnClick: true,
        theme: 'colored',
        icon: false,
    });
};

export const successToast = (
    msg: React.ReactNode | string,
    {
        autoClose = 3999,
        detail,
        closeOnClick = true,
    }: MessageOptions = {}
) => {
    const content = detail
        ? <ExpandableToastMessage message={msg} detail={detail} />
        : msg;
    toast.success(content, {
        position: 'top-center',
        pauseOnHover: false,
        hideProgressBar: true,
        autoClose,
        closeOnClick: detail ? false : closeOnClick,
        theme: 'colored',
        icon: false,
    });
};

// more work should be done here!
export const warningToast = (msg: React.ReactNode | string, autoClose: boolean = false) => {
    toast.warn(msg, {
        draggable: true,
        position: 'top-center',
        pauseOnHover: true,
        hideProgressBar: true,
        autoClose: autoClose ? 2999 : false,
        closeOnClick: true,
        theme: 'colored',
        icon: false,
  });
};

export type MessageOptions = {
    autoClose?: number | false,
    pauseOnHover?: boolean,
    customID?: string,
    closeOnClick?: boolean,
    detail?: string,
};

export const errorToast = (
  msg: React.ReactNode | string,
  {
    autoClose = false,
    pauseOnHover = false,
    customID,
    closeOnClick = true,
    detail,
  }: MessageOptions = {}
) => {
    const content = detail
        ? <ExpandableToastMessage message={msg} detail={detail} />
        : msg;
    toast.error(content, {
        position: 'top-center',
        pauseOnHover,
        hideProgressBar: !pauseOnHover,
        autoClose,
        closeOnClick: detail ? false : closeOnClick,
        theme: 'colored',
        toastId: customID ?? Date.now(),
        icon: false,
    });
};
